<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import createModal from "./create_modal.vue";
import DetailModal from "./detail_modal.vue";
import datatableMixin from '@/helpers/mixins/datatableMixin';
import Datatable from '@/components/Datatable';

export default {
  page: {
    title: "Router Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    createModal,
    DetailModal,
    Datatable,
  },
  mixins: [datatableMixin],
  data() {
    return {
      list: {},
      detailRouter: {},
      detailModalOpen: 0,
      title: "ROUTER LİSTESİ",
      items: [
        { text: "ANASAYFA", href: "/" },
        { text: "ROUTER LİSTESİ", active: true },
      ],
      columns: [
        { name: '', key: 'action', orderable: false, width: 10 },
        { name: 'Router İp', key: 'nasname', width: 150 },
        { name: 'Router Adı', key: 'shortname', className: 'text-end', orderable: true, width: 150 },
        { name: 'Açıklama', key: 'description', className: 'text-end', width: 150 },
        { name: 'Durum', key: 'status', className: 'text-end', width: 150 },
      ],
      tableData: {
        detail: false,
        excel: false,
        searchable: {
          visible: true,
          placeholder: "Router Adı, Ip de Ara",
        },
      },
      endpoint: '/routers',
    };
  },
  methods: {
    async loadPage() {
      this.params.page === 1 ? this.isLoading = true : this.pageLoading = true;

      const response = await this.$http.post(this.endpoint, {
        params: this.params,
        search_params: this.searchParams,
        sort: this.sort,
        search_query: this.searchQuery,
      });

      if (this.params.page === 1) {
        this.tableData.data = response.data.data;
      } else {
        this.tableData.data = [...this.tableData.data, ...response.data.data];
      }

      this.tableData.pagination = response.data.meta;
      this.params.page === 1 ? this.isLoading = false : this.pageLoading = false;
    },

    create() {
      this.list = {};
      this.$parent.$bvModal.show('modal-scoped');
    },

    update(props) {
      this.list = props;
      this.$parent.$bvModal.show('modal-scoped');
    },

    openDetail(row) {
      this.detailRouter = {
        id: row.id,
        title: row.shortname,
        subtitle: row.nasname,
      };
      this.detailModalOpen = Date.now();
      this.$parent.$bvModal.show('router_detail_modal');
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <create-modal :list="list" @loadItems="loadPage" />
    <DetailModal
      :device="detailRouter"
      :modelOpen="detailModalOpen"
      endpoint="/routers/details"
      title="Router Detay"
      modalId="router_detail_modal"
    />

    <div class="row">
      <div class="col-12">
        <Datatable
          :columns="columns"
          :tableData="tableData"
          @sort-column="handleSortColumn"
          @search-query="reLoadPage"
          @excel-export="excelExport"
          :loading="isLoading"
          :poading="pageLoading"
        >
          <template #button>
            <button class="btn btn-sm btn-success" @click="create()">Yeni Oluştur</button>
          </template>

          <template #status="{ row }">
            <span v-if="row.status_id" class="badge rounded-pill bg-success"><i class="fa fa-check"></i> Aktif</span>
            <span v-if="!row.status_id" class="badge rounded-pill bg-danger"><i class="fa fa-times"></i> Pasif</span>
          </template>

          <template #action="{ row }">
            <b-dropdown
              toggle-class="font-size-16 p-0"
              toggle-tag="a"
              variant="white"
              append-to-body
            >
              <template #button-content>
                <i class="mdi mdi-dots-horizontal"></i>
              </template>
              <b-dropdown-item @click="openDetail(row)">Detay</b-dropdown-item>
              <b-dropdown-item @click="update(row)">Güncelle</b-dropdown-item>
            </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>
